import {
  AGRIWEBB_SCOPES,
  AUTHORIZE_URL,
  INSTALL_RESPONSE_TYPE
} from 'constants/agriwebb';
import { WhiteLabelTitle } from 'types/models/white-label';
import getBaseUrl from 'utils/App/get-base-url';
import getWhiteLabelConfig from 'utils/get-white-label-config';

export default function createAgriWebbAuthorizeUrl(
  organizationCode: string
): string {
  const {
    VITE_AGRIWEBB_FARMBOT_CLIENT_ID,
    VITE_AGRIWEBB_RANCHBOT_CLIENT_ID,
    VITE_AGRIWEBB_BASE_URL,
    VITE_URL_SCHEME,
    VITE_URL_DEFAULT_SUBDOMAIN,
    VITE_URL_DOMAIN,
    VITE_URL_RANCHBOT_DOMAIN
  } = import.meta.env;
  const { title: whiteLabel } = getWhiteLabelConfig();

  const clientId =
    whiteLabel === WhiteLabelTitle.RANCHBOT
      ? VITE_AGRIWEBB_RANCHBOT_CLIENT_ID
      : VITE_AGRIWEBB_FARMBOT_CLIENT_ID;

  const farmbotBaseURL = getBaseUrl();
  const ranchbotBaseURL = `${VITE_URL_SCHEME}${VITE_URL_DEFAULT_SUBDOMAIN}.${VITE_URL_RANCHBOT_DOMAIN}`;
  const baseAppUrl =
    whiteLabel === WhiteLabelTitle.RANCHBOT ? ranchbotBaseURL : farmbotBaseURL;

  let agriWebbAuthorizeUrl = `${VITE_AGRIWEBB_BASE_URL}${AUTHORIZE_URL}?`;
  agriWebbAuthorizeUrl += `response_type=${INSTALL_RESPONSE_TYPE}`;
  agriWebbAuthorizeUrl += `&client_id=${clientId}`;
  agriWebbAuthorizeUrl += `&redirect_uri=${baseAppUrl}/connections/agriwebb/install-callback`;
  agriWebbAuthorizeUrl += `&organization=${organizationCode}`;
  agriWebbAuthorizeUrl += `&scope=${AGRIWEBB_SCOPES}`;

  return agriWebbAuthorizeUrl;
}
